import React, { useState } from "react";
import { useHistory } from "react-router-dom";

import http from "../../services/axios";
import lbl from "../../data/Labels.json";

const AccountPasswordForm = ({
  mustChangePassword = false,
  skipCurrentPassword = false,
  showBackLink = false,
  onSuccess,
}) => {
  const history = useHistory();
  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [message, setMessage] = useState("");
  const [saving, setSaving] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage("");

    if (newPassword.length < 8) {
      setMessage(lbl.PasswordMinLength || "رمز جدید باید حداقل ۸ حرف باشد.");
      return;
    }
    if (newPassword !== confirmPassword) {
      setMessage(lbl.PasswordMismatch || "تکرار رمز عبور مطابقت ندارد.");
      return;
    }

    setSaving(true);
    try {
      const body = {
        new_password: newPassword,
        new_password_confirm: confirmPassword,
      };
      if (!skipCurrentPassword) {
        body.current_password = currentPassword;
      }
      const { data } = await http.post("/login/change-password", body);
      if (data?.ok) {
        setMessage(data.message || lbl.PasswordSaved);
        setCurrentPassword("");
        setNewPassword("");
        setConfirmPassword("");
        window.dispatchEvent(new Event("aria-auth-changed"));
        if (typeof onSuccess === "function") {
          onSuccess(data);
        } else if (mustChangePassword) {
          history.replace("/mis/stats");
        }
      } else {
        setMessage(data?.message || lbl.SaveFailed);
      }
    } catch (_err) {
      setMessage(lbl.SaveFailed || "خطا در تغییر رمز.");
    } finally {
      setSaving(false);
    }
  };

  return (
    <form className="account-password-form" onSubmit={handleSubmit}>
      {mustChangePassword ? (
        <p className="account-password-hint">
          {lbl.MustChangePasswordHint || "لطفاً رمز عبور جدید خود را تنظیم کنید."}
        </p>
      ) : null}
      {!skipCurrentPassword ? (
        <div className="account-form-row">
          <label htmlFor="current_password">{lbl.CurrentPassword || "رمز فعلی"}</label>
          <input
            id="current_password"
            type="password"
            value={currentPassword}
            onChange={(ev) => setCurrentPassword(ev.target.value)}
            autoComplete="current-password"
            dir="ltr"
          />
        </div>
      ) : null}
      <div className="account-form-row">
        <label htmlFor="new_password">{lbl.NewPassword || "رمز جدید"}</label>
        <input
          id="new_password"
          type="password"
          value={newPassword}
          onChange={(ev) => setNewPassword(ev.target.value)}
          autoComplete="new-password"
          dir="ltr"
        />
      </div>
      <div className="account-form-row">
        <label htmlFor="confirm_password">{lbl.ConfirmPassword || "تکرار رمز جدید"}</label>
        <input
          id="confirm_password"
          type="password"
          value={confirmPassword}
          onChange={(ev) => setConfirmPassword(ev.target.value)}
          autoComplete="new-password"
          dir="ltr"
        />
      </div>
      <div className="account-password-actions">
        <button type="submit" className="account-save-btn" disabled={saving}>
          {saving ? "..." : mustChangePassword ? lbl.SetPassword || "تنظیم رمز عبور" : lbl.ChangePassword}
        </button>
        {showBackLink && !mustChangePassword ? (
          <button
            type="button"
            className="account-back-btn"
            onClick={() => history.push("/mis/my-profile")}
          >
            {lbl.PrevPage}
          </button>
        ) : null}
      </div>
      {message ? (
        <p
          className={`account-form-feedback ${
            message.includes("خطا") || message.includes("اشتباه") ? "error" : "ok"
          }`}
        >
          {message}
        </p>
      ) : null}
    </form>
  );
};

export default AccountPasswordForm;
